import { FCalcAgg, FCalcScalar } from './FormulaFunc';
import { AVG, COUNT, COUNTD, MAX, MIN, SUM } from './Funcs/AggFunc';
import { DATENAME, DATEPART, DATETRUNC } from './Funcs/DateFunc';
import { LOG } from './Funcs/MathFunc';
import { DATEPARSE, STR } from './Funcs/TypeFunc';
export class FuncProvider {
    getFunc(name, args) {
        switch (name) {
            // Aggregates
            case 'AVG':
                return new AVG(args);
            case 'COUNT':
                return new COUNT(args);
            case 'COUNTD':
                return new COUNTD(args);
            case 'MAX':
                return new MAX(args);
            case 'MIN':
                return new MIN(args);
            case 'SUM':
                return new SUM(args);
            // Dates
            case 'DATENAME':
                return new DATENAME(args);
            case 'DATEPART':
                return new DATEPART(args);
            case 'DATETRUNC':
                return new DATETRUNC(args);
            // Numbers
            case 'LOG':
                return new LOG(args);
            // Types
            case 'DATEPARSE':
                return new DATEPARSE(args);
            case 'STR':
                return new STR(args);
        }
    }
    getCalcFunc(field) {
        const expr = field.formula.expr;
        switch (expr.type) {
            case 'SCALAR':
                return new FCalcScalar(field.name, expr);
            case 'AGG':
                return new FCalcAgg(field.name, expr);
        }
    }
}
